import React from 'react'
import RightContent from '../../components/OnBoard/RightContent'
import styles from "./UserOnboarding2.module.css"
import UserOnboardingSteps from '../../components/OnBoard/UserOnboardingSteps'
import { Icon } from "react-icons-kit"
import { mapMarker } from 'react-icons-kit/fa/mapMarker'
import { plane } from 'react-icons-kit/fa/plane'
import { useNavigate } from 'react-router-dom'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'

const UserOnboarding4 = () => {
  const companyRegistration = [
    {
      id: 1,
      icon: plane,
      title: "Overseas Entity",
      subTitle: "Incorporated outside India.",
      onClick: "/app/registration/business-details-overseas"
    },
    {
      id: 2,
      icon: mapMarker,
      title: "Indian Company",
      subTitle: "Registered in India.",
      onClick: "/app/registration/onshore-status"
    }
  ]
  const navigate = useNavigate()

  return (
    <SlideUpWrapper>
      <div className={styles.userOnboarding}>
        <RightContent step={2} />
        <section className={styles.leftContent}>
          <div
            className={styles.progressForm}
            style={{ height: "100%", width: "100%", maxWidth: "900px", padding:"3rem 1.25rem" }}
          >
            <div className={styles.progressForm1}>
              <div className={styles.onboardingStep}>
                <UserOnboardingSteps stepNo={1} />
              </div>
              <div className={styles.headingHelperText}>
                <h1
                  className={styles.heading}
                  style={{ fontSize: "clamp(22px, 3vw, 30px)", textAlign: "left" }}
                >
                  Where is your entity registered?
                </h1>
                <div>
                  <p
                    className={styles.supportingText}
                    style={{ textAlign: "left", marginTop: "0px" }}
                  >
                    Your jurisdiction shapes the documents we request and the compliance frameworks applied to your account.
                  </p>
                </div>
              </div>

              <div className={styles.companyDetails}>
                {companyRegistration.map((i) => (
                  <div
                    className={styles.companyDetailsContainer}
                    key={i.id}
                    onClick={() => navigate(i.onClick)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') navigate(i.onClick)
                    }}
                  >
                    <div className={styles.companyIcon}>
                      <Icon icon={i.icon} size={25} />
                    </div>
                    <div className={styles.companyTitle}>{i.title}</div>
                    <div
                      className={`${styles.supportingText} ${styles.companySubtitle}`}
                      style={{alignSelf:"flex-start"}}
                    >
                      {i.subTitle}
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <img
                        className={styles.rightIcon}
                        src="/Chevron-Right.svg"
                        alt="Continue"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </SlideUpWrapper>
  )
}

export default UserOnboarding4